<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        
        <div class="modal-container">
          <div class="row">
            <div class="col-12 x">
              <button class="modal-default-button arrow" @click="$emit('close')">x</button>
            </div>
          </div>
          <form action="">
            <div class="form-section row" transition="start">
              <div class="col-lg-6 col-sm-12">
                <div class="form-group">
                  <label for="firstName">{{ $t('labelFirstName') }}</label>
                  <input type="text" name="firstName" v-model="firstName"/>
                  <p v-if="error.in.firstName">{{ $t('errorFirstName') }}</p>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12">
                <div class="form-group">
                  <label for="lastName">{{ $t('labelLastName') }}</label>
                  <input type="text" name="lastName" v-model="lastName"/>
                  <p v-if="error.in.lastName">{{ $t('errorLastName') }}</p>
                </div>
              </div>
            </div>
            <div class="form-section row">
              <div class="col-lg-6 col-sm-12">
                <div class="form-group">
                  <label for="email">{{ $t('labelEmail') }}</label>
                  <input type="text" name="email" v-model="email"/>
                  <p v-if="error.in.email">{{ $t('errorEmail') }}</p>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12">
                <div class="form-group">
                  <label for="phone">{{ $t('labelPhone') }}</label>
                  <input type="text" name="phone" v-model="phone"/>
                  <p v-if="error.in.phone">{{ $t('errorPhone') }}</p>
                </div>
              </div>
            </div>
            <div class="form-section row">
              <div class="col-12">
                <div class="form-group">
                  <label for="company">{{ $t('labelCompany') }}</label>
                  <input type="text" name="company" v-model="company"/>
                  <p v-if="error.in.company">{{ $t('errorCompany') }}</p>
                </div>
              </div>
            </div>
            <div class="form-section row">
              <div class="col-12">
                <div class="form-group">
                  <label for="message">{{ $t('labelMessage') }}</label>
                  <textarea name="message" v-model="message"></textarea>
                  <p v-if="error.in.message">{{ $t('errorMessage') }}</p>
                </div>
              </div>
            </div>
            <div class="form-section row">
              <div class="col-12">
               <button class="button" type="submit" @click.prevent="submitForm">{{ $t('labelSend') }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import axios from 'axios';

export default {
  name: 'contact-form',
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      company: '',
      message: '',
      error: {
        in: {
          firstName: false,
          lastName: false,
          email: false,
          phone: false,
          message: false,
          company: false,
        },
      },
      postBody: '',
      errors: [],
    };
  },
  methods: {
    submitForm() {
      this.error.in.firstName = (this.firstName === '');
      this.error.in.email = (this.email === '');
      if (this.error.in.firstName || this.error.in.email) return false;
      const params = new URLSearchParams();
      params.append('Name', this.firstName);
      params.append('LastName', this.lastName);
      params.append('Company', this.company);
      params.append('eMail', this.email);
      params.append('PhoneNumber', this.phone);
      params.append('Subject', 'New Contact from Sprinter WebSite');
      params.append('Comments', this.message);
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      axios.post('http://www.springter.com:8081/api/filledform', params)
      .then(() => {
        // console.log(response);
        this.$emit('close');
        return true;
      })
      .catch((e) => {
        this.errors.push(e);
        this.$emit('close');
        return true;
      });
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>

.form-group{
  margin-bottom: 10px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

p{
  color: $color--brand-secondary;
  font-size: $p--small;
  font-style: italic;
}

.modal-container {
  width: 50%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: rgba(0, 0, 0, .5);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;

  @include mq('phablet', 'max') {
    padding: 10px 15px;
  }

  @include mqlandscape(){
    padding: 10px 15px;
  }
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;

  &:hover{
    border-color: $color--brand-primary;
    color: $color--brand-primary;
  }
}

.x{
  height: 40px;
}

input[type="text"] {
    border: none;
    padding: 10px;
}

textarea {
    resize: vertical;
    min-height: 80px;
    height: 100%;
    border: none;
    padding: 10px;
    height: fit-content;
}

button{
  border: none;
}

button.arrow {
    cursor: pointer;
    top: 93%;
    width: 35px;
    height: 35px;
    border: 3px solid $color--white;
    border-radius: 20px;
    stroke: $color--white;
    -webkit-transition: all 150ms ease-in-out;
    transition: all 150ms ease-in-out;
    stroke-width: 10;
}

.arrow{
  color: $color--white;
  text-transform: uppercase;
  font-family: $stack--big-letters;
}

label{
  color: $color--white;
  text-transform: uppercase;
  font-family: $stack--big-letters;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/*---
RESPONSIVE
---*/

.modal-container[data-v-18e153b9] {
   @include mq('phablet', 'max') {
     width: 90%;
   }
}

.modal-container[data-v-18e153b9] {
   @include mqlandscape() {
     width: 90%;
   }
}

.modal-container[data-v-18e153b9] {
   @include mq('tablet-wide', 'max') {
     width: 90%;
   }
}

.col-lg-6.col-sm-12 {
  @include mq('phablet', 'max') {
    margin-bottom: 5%;
  }
}

.col-lg-6.col-sm-12 {
  @include mqlandscape() {
    margin-bottom: 5%;
  }
}

.col-lg-6.col-sm-12 {
  @include mq('tablet-wide', 'max') {
    margin-bottom: 5%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/ContactForm.vue